import { Page, Text, View, Document, Image } from '@react-pdf/renderer';

// Constants
import { CV_TEMPLATE_ID, IMAGES } from '@shared/constants';
import { ExportFormat } from '@/constants/resume';

// Utils
import { filterValidSkills, buildFileName } from '@/utils/resume';

// Types
import { TemplateProps } from '../../type';

// Styles
import styles from './style';

// Tokens
import { CONFIDENTIALITY_NOTICE } from '../tokens';

// Components
import PersonalInfoSection from './components/PersonalInfo';
import TechnicalSkillsSection from './components/TechnicalSkills';
import ExperienceSection from './components/Experiences';
import EducationSection from './components/Education';
import CertificationsSection from './components/Certificates';
const AgilityIO = ({
  data
}: TemplateProps) => {
  const {
    info,
    technicalSkills,
    journeys,
    educations,
    certs
  } = data || {};
  const {
    name = '',
    title = '',
    address = '',
    bio = ''
  } = info || {};
  const fileName = buildFileName(ExportFormat.PDF, name);
  const filteredSkills = filterValidSkills(technicalSkills ?? []);

  // Header
  const renderHeader = () => <View style={styles.header} fixed data-sentry-element="View" data-sentry-component="renderHeader" data-sentry-source-file="index.tsx">
      <Image style={styles.logo} src={'/images/agility-logo.png'} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </View>;

  // Footer
  const renderFooter = () => <View style={styles.footer} fixed data-sentry-element="View" data-sentry-component="renderFooter" data-sentry-source-file="index.tsx">
      <Text style={styles.footerText} data-sentry-element="Text" data-sentry-source-file="index.tsx">{CONFIDENTIALITY_NOTICE}</Text>
    </View>;
  return <Document title={fileName} data-sentry-element="Document" data-sentry-component="AgilityIO" data-sentry-source-file="index.tsx">
      <Page size="LETTER" style={styles.page} data-sentry-element="Page" data-sentry-source-file="index.tsx">
        {renderHeader()}

        <View style={styles.body} data-sentry-element="View" data-sentry-source-file="index.tsx">
          <PersonalInfoSection name={name} title={title} address={address} bio={bio} data-sentry-element="PersonalInfoSection" data-sentry-source-file="index.tsx" />
          <TechnicalSkillsSection filteredSkills={filteredSkills} data-sentry-element="TechnicalSkillsSection" data-sentry-source-file="index.tsx" />
          <ExperienceSection journeys={journeys} data-sentry-element="ExperienceSection" data-sentry-source-file="index.tsx" />
          <EducationSection educations={educations} data-sentry-element="EducationSection" data-sentry-source-file="index.tsx" />
          {/* TODO: Support later - Languages section */}
          <CertificationsSection certs={certs} data-sentry-element="CertificationsSection" data-sentry-source-file="index.tsx" />
        </View>

        {renderFooter()}
      </Page>
    </Document>;
};
export const AGILITYIO_TEMPLATE_INFO = {
  id: CV_TEMPLATE_ID.AGILITYIO,
  title: 'AgilityIO',
  description: 'A modern, clean single-column resume template focusing on structure and clarity.',
  thumbnail: IMAGES.CV_TEMPLATE,
  // TODO: Update with real thumbnail
  component: AgilityIO
};
export default AgilityIO;